import React from "react";
import pik1 from "./pik1.json";
import "./pik1.scss";
import Cardrumah from "../../../component/cardrumah/cardrumah.jsx";
import emeralda from "../../../asset/pik1/emeralda/emeralda.js";
import crowdm from "../../../asset/pik1/crowdm/crowdm.js";
const imageMap = {
  emeralda,
  crowdm,
  // Add other image arrays here if you have more sets
};

const Pik1 = () => {
  return (
    <div className="pik1">
      <div className="container-pik1">
        <div className="header">
          <div className="judul-pik1">
            <div className="pink"></div>
            <span>
              Pantai Indah Kapuk 1 <b>(Last Cluster)</b>
            </span>
          </div>
        </div>
        <div className="cardhome-container">
          {pik1.cards.map((card, index) => {
            // Determine the logo dynamically
            return (
              <Cardrumah
                key={index}
                carousel={imageMap[card.imagesKey]}
                title={card.title}
                subtitle={card.subtitle}
                price={card.price}
                subprice={card.subprice}
                details={card.details}
                whatsappLink={card.whatsappLink} // Pass the WhatsApp link
              />
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Pik1;
